/* eslint-disable no-unused-vars, react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { getFunctions, httpsCallable } from "firebase/functions";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const eoId = searchParams.get("eoId");
  const mpsId = searchParams.get("mpsId");

  useEffect(() => {
    const logPaymentStatus = async () => {
      try {
        const sessionId = searchParams.get("session_id");
        const paymentStatus = searchParams.get("payment_status");

        console.log("Session ID:", sessionId);
        console.log("Payment Status:", paymentStatus);
        console.log("Event ID:", id);
        console.log("EO ID:", eoId);
        console.log("MPS ID:", mpsId);

        const functions = getFunctions();
        const logPayment = httpsCallable(functions, "logPaymentStatus");

        await logPayment({
          eventId: id,
          eoId: eoId,
          mpsId: mpsId,
          status: "success",
          sessionId,
          paymentStatus,
        });
      } catch (error) {
        console.error("Error logging payment status:", error);
      } finally {
        navigate(`/mps/view-event-details/${id}`);
      }
    };

    logPaymentStatus();
  }, [id, navigate, searchParams]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full space-y-8 p-8 bg-white rounded-lg shadow-lg">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-green-600 mb-4">
            Payment Successful!
          </h2>
          <p className="text-gray-600">Redirecting you back to the event...</p>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
